import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Link, Typography, Stack } from '@mui/material';
// routes
import { PATH_AUTH } from '../../routes/paths';
// layouts
import AuthLayout from '../../layouts/AuthLayout';
// components
import Page from '../../components/Page';
import Logo from '../../components/Logo';
import useAuth from '../../hooks/useAuth';
// sections
import { LoginForm } from '../../sections/auth/login';
import { APP_NAME } from '../../config';

// ----------------------------------------------------------------------

export default function Login() {
  const { setting } = useAuth();
  const appName = setting?.general?.app_name || APP_NAME;

  return (
    <Page title="Login">
      <AuthLayout>
        {/* Enlarged branding logo and appName text (removed Business text) */}
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 4 }}>
          <Logo sx={{ width: 52, height: 52 }} disabledLink />
          <Typography variant="h4" sx={{ fontWeight: 900, color: 'primary.main', textTransform: 'uppercase', letterSpacing: 0.5 }}>
            {appName}
          </Typography>
        </Stack>

        <Stack spacing={0.5} sx={{ mb: 2 }}>
          <Typography variant="h4" sx={{ fontWeight: 800 }}>
            Login
          </Typography>
        </Stack>

        <LoginForm />

        {/* Footer links: centered signup link (Original portal login hidden) */}
        <Stack direction="row" justifyContent="flex-start" alignItems="center" sx={{ mt: 2.5 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
            Don't have an account?{' '}
            <Link component={RouterLink} to={PATH_AUTH.register} sx={{ color: 'primary.main', fontWeight: 700, textDecoration: 'none' }}>
              Sign up
            </Link>
          </Typography>
        </Stack>
      </AuthLayout>
    </Page>
  );
}
